import { Dispatch } from 'redux'
import {
  apiRequest,
  apiFailure,
  sendContactMessage as sendContactMessageReducer,
  subscribe as subscribeReducer,
} from 'reducers/landing.reducer'
import { landingService } from 'services/landing.service'
import IContact from 'models/IContact'
import IUserInfo from 'models/IUserInfo'

export const sendContactMessage =
  (messageBody: IContact) => async (dispatch: Dispatch) => {
    try {
      dispatch(apiRequest())

      const response = await landingService.sendContactMessage(messageBody)
      if (response) {
        dispatch(sendContactMessageReducer())
      }
    } catch (error) {
      dispatch(apiFailure())
    }
  }

export const subscribe =
  (userInfo: IUserInfo) => async (dispatch: Dispatch) => {
    try {
      dispatch(apiRequest())

      const response = await landingService.subscribe(userInfo)
      if (response) {
        dispatch(subscribeReducer(response))
      }
    } catch (error) {
      dispatch(apiFailure())
    }
  }
